import Layout from 'components/Layout';
import styles from './styles.module.scss';

interface ForbiddenProps {
	text: string | null;
	userName?: string;
	userLogin?: string;
}

export default function Forbidden({ text, userName, userLogin }: ForbiddenProps) {
	const userInfo = userName || userLogin
		? `${userName || ''}${userLogin ? ` (${userLogin})` : ''}, `
		: '';

	const defaultText = 'У вас недостаточно прав для получения данной функциональности. Обратитесь в Сервис деск компании.';
	const fullText = text || defaultText;
	const message = userInfo ? fullText.charAt(0).toLowerCase() + fullText.slice(1) : fullText;

	return (
		<Layout>
			<div className={`${styles.forbidden} row`}>
				<div className="column-md-7">
					{userInfo}{message}
				</div>
			</div>
		</Layout>
	);
}
